// ./src/utils/publishGate.ts
//
// ROADMAP #198 a (owner, 2026-10-21: "publisher's email") — an event going PUBLIC for the first time needs the publisher's
// own email confirmed. The server decides (`EventCore.publisherEmailRefusal`); this mirrors WHEN it asks, so the screens
// that publish can say so BEFORE the host presses Publish, and send them to confirm it and back.
// ⚠ Never retroactive: a live event, or one public before (`publishedAt`), is not held.
// ⓘ Pure — `check-account-onboarding` RUNS it. The API's rule: `publishNeedsConfirmedEmail` (src/boundary/event.ts).

/** The field the server keys the refusal by (mirrors the API's `PUBLISH_EMAIL_FIELD`). */
export const PUBLISH_EMAIL_FIELD = 'emailConfirmation';

const PUBLISHED = 'published';

/** Is publishing this event asked about the publisher's email? (null event → nothing to publish, nothing held.) */
export const publishNeedsConfirmedEmail = (event: { eventStatus?: string | null; publishedAt?: string | null } | null | undefined): boolean =>
  !!event && event.eventStatus !== PUBLISHED && !event.publishedAt;

/** Held: this event would be refused for the signed-in user's unconfirmed email. ⚠ Unknown (no user) is held — the server refuses it too. */
export const publisherEmailHeld = (
  user: { emailConfirmation?: boolean | null } | null | undefined,
  event: { eventStatus?: string | null; publishedAt?: string | null } | null | undefined,
): boolean => publishNeedsConfirmedEmail(event) && user?.emailConfirmation !== true;
